import Vue, { FunctionalComponentOptions, CreateElement, RenderContext } from 'vue';

export default <FunctionalComponentOptions>{
    functional: true,

    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        layout: {
            type: String,
            default: 'horizontal',
            validator: val => ['horizontal', 'vertical'].includes(val)
        },
        legend: {
            type: String,
            default: undefined
        }
    },

    render: function(h: CreateElement, ctx: RenderContext) {
        return h(
            'fieldset', { class: [
                'wok--checkbox-group',
                { 'wok--checkbox-group--disabled': ctx.props.disabled }, 
                ctx.data.staticClass
            ]},  
            [
                hasLegend(ctx) && h('legend', { class: 'wok--input__label wok--label-01' }, [
                    ctx.props.legend || ctx.slots().legend
                ]),
                h('div', { class: `wok--checkbox-group__items-wrapper--${ctx.props.layout}` }, [
                    ctx.slots().content
                ])
            ]
        )
    }
}

function hasLegend(ctx: RenderContext) {
    return ctx.props.legend || ctx.slots().legend;
}